export const PROFIT_LOSS_ID = 'id-profit-and-loss';

export const BALANCE_SHEET_ID = 'id-balance-sheet';

export const CASH_FLOW_ID = 'id-cash-flow';

export const ROW_FORMULA_ID = 'id-row-formula';

export const NON_FINANCIAL_DRIVERS_ID = 'id-non-financial-drivers';

export const CATEGORY_IDS = [PROFIT_LOSS_ID, BALANCE_SHEET_ID, ROW_FORMULA_ID, CASH_FLOW_ID, NON_FINANCIAL_DRIVERS_ID];

export const ROW_FORMULA_GROUP_IDS = [
  'Sales-id-row-formula',
  'Expenses-id-row-formula',
  'Profit-id-row-formula',
  'Balance sheet-id-row-formula',
  'Cash flow-id-row-formula',
  'People-id-row-formula',
  'Ratios-id-row-formula'
];
